import React, { useEffect } from 'react'
import { loadLocation } from '~/state/modules/locations'
import { useDispatch, useSelector } from 'react-redux'
import { createLayout } from '~/state/modules/planimetry'
import { PaperContainer } from '~/views/shared'
import { LayoutForm } from '../LayoutForm'
import { ROUTES } from '~/views/routes'
import history from '~/config/history'
import { showSnackbarError, showSnackbarSuccess } from 'views/utils/snackbar'

export const LayoutCreatePage = ({ match, onSuccess }) => {
  const dispatch = useDispatch()
  const { pendingCreateLayout } = useSelector((state) => state.planimetry)
  const { location } = useSelector((state) => state.locations)
  const { locationId } = match.params

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true)
      await dispatch(createLayout(values))
      onSuccess(locationId)
      showSnackbarSuccess('Planimetria Creada!')
    } catch (error) {
      showSnackbarError(error)
    } finally {
      setSubmitting(false)
    }
  }

  const values = {
    LayoutName: '',
    ImageFile: null,
    LocationId: locationId
  }

  useEffect(() => {
    async function fetchData() {
      await dispatch(loadLocation(locationId))
    }

    fetchData().then()
    // eslint-disable-next-line
  }, [match])

  return (
    <>
      <PaperContainer
        title={`Creación de Planimetria para "${location ? location.Name : '-'}"`}>
        <LayoutForm
          values={values}
          actionText='Crear'
          handleSubmit={handleSubmit}
          actionPending={pendingCreateLayout}
          onCancel={() =>
            history.push(
              ROUTES.ADMIN.LOCATIONS.PLANIMETRY.INDEX.replace(
                ':locationId',
                locationId
              )
            )
          }
        />
      </PaperContainer>
    </>
  )
}

export default LayoutCreatePage
